import {apiUrl, mainWebPostData} from '../../../config/net'
import api from '../../../tools/api-tools'
import resUrl from './resource-url'

class BindItem {
  constructor () {
    this.formData = {
      industryId: {},
      couponCode: ''
    }
  }

  // 格式化获取用户当前版本及之前版本
  _schemaVersion (data) {
    return {
      canOnlyBindIndustryVersion: data.canOnlyBindIndustryVersion,
      targetIndustryVersion: data.targetIndustryVersion,
      leftDays: data.leftDays,
      versionName: data.versionName,
      beforeVersion: data.beforeVersion,
      currentVersion: data.currentVersion
    }
  }

  // 格式化获取卡片信息
  _schemaCardInfo (data) {
    return {
      id: data.id,
      isValid: data.isValid,
      message: data.message,
      name: data.name || '-',
      couponVal: data.couponVal,
      couponStatus: data.couponStatus,
      forAdvance: data.forAdvance,
      isCommonIndustryCoupon: data.isCommonIndustryCoupon
    }
  }

  getUserVersion () {
    return api.get(`${apiUrl}/v0/onlinemall/version/avaliable`).then(res => {
      let data = res.data.data || {}
      return this._schemaVersion(data)
    })
  }

  getCardInfo () {
    return api.get(`${apiUrl}/v0/onlinemall/coupon/info?couponcode=${this.formData.couponCode}`).then(res => {
      return this._schemaCardInfo(res.data || {})
    })
  }

  bindCard () {
    return api.post(`${apiUrl}/v0/onlinemall/coupon/bind`, {
      couponCode: this.formData.couponCode
    }).then(res => {
      return res.data
    })
  }

  activateCard (couponId) {
    let couponObj = {CouponId: couponId, BindValue: this.formData.industryId.value}
    return api.post(resUrl.activeCard.url, mainWebPostData(resUrl.activeCard.method, couponObj)).then(res => {
      return res.data
    })
  }
}

export default BindItem



// WEBPACK FOOTER //
// ./src/model/coupon/card-bind/index.js